<template>
  <v-btn
    rounded
    depressed    
    small
    :color="color"
    :loading="loading"
    :disabled="loading || disabled"
    :style="styles"
    :block="block"
    @click="$emit(emit)"
  >
    <v-icon left small>{{ icon }}</v-icon>
    <span>{{ text }}</span>
  </v-btn>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    styles: {
      type: String,
      default: "",
    },
    emit: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "",
    },
    block: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
</style>